/**
 * /eric — operator surface shell (T-048, Phase I).
 *
 * Replaces the Phase C (T-018) stub with a TanStack layout route. The
 * `beforeLoad` guard runs `requireOperatorEntry` (which itself reuses the
 * Phase C `requireOperator` contract); unauthenticated -> /auth/sign-in,
 * non-operator -> notFound() (the surface must not leak existence).
 *
 * The component renders `OperatorLayout` with a child `<Outlet />`. All
 * `/eric/*` flat dot-routes (eric.tsx as the layout, eric.<segment>.tsx as
 * children) nest into this outlet — TanStack file-based routing treats
 * dot-separated paths as parent-child by default.
 *
 * Phase C contract preserved: the routed surface is still operator-gated by
 * the same guard helpers; this widening only adds the layout chrome that
 * Phase I needs. The `/eric` path itself now renders the Today view via
 * `eric.index.tsx` (T-049).
 */

import { Outlet, createFileRoute } from '@tanstack/react-router';
import {
  OperatorLayout,
  OperatorTooNarrow,
} from '@/components/operator/OperatorLayout';
import { requireOperatorEntry } from '@/lib/operator-guard';
import { Toaster } from '@/components/ui/toast';

export const Route = createFileRoute('/eric')({
  beforeLoad: async ({ location }) => {
    const operator = await requireOperatorEntry({
      redirectFrom: location.pathname,
    });
    return { operator };
  },
  component: OperatorShell,
});

function OperatorShell() {
  const { operator } = Route.useRouteContext();
  return (
    <>
      <OperatorLayout userId={operator.userId} email={operator.email}>
        <Outlet />
      </OperatorLayout>
      <OperatorTooNarrow />
      <Toaster position="bottom-right" richColors closeButton />
    </>
  );
}
